//
// Javascript for the HEIDateEdit input control
//
//  Matt Smith
//
HEIJS.registerNamespace("HEIJS.Controls");
HEIJS.Controls.HEIDateEdit = function (opt, parentElem)
{
  var inputs;
  if (parentElem)  
    inputs = $('input[type=text].heidatepicker', parentElem);
  else
    inputs = $('input[type=text].heidatepicker');
	
  if (inputs.length == 0)
    return;
  var calendarService = new RESTService({ baseUrl: HEIJS.context.convertToContextUri('https://companycalendars.hendersonengineers.com'), routePrefix: 'CompanyCalendarService/API' });

  function setInput(inputs, holidays) {
    var options = {
      showOn: 'both',
      buttonImage: HEIJS.context.getResourceUri("/resources/images/icons/datetime.png"),
      buttonImageOnly: true,
      changeYear: true,
      changeMonth: true,
      duration: 100,
      gotoCurrent: true,
      fixFocusIE: false,    
      onSelect: function(dateText, inst) {
        this.fixFocusIE = true;
        $(this).blur().change().focus();
      },
      onClose: function(dateText, inst) {
        this.fixFocusIE = true;
        $(this).focus();
      },
      beforeShow: function(input, inst) {
        var result = $.browser.msie ? !this.fixFocusIE : true;
        this.fixFocusIE = false;
        return result;
      },
      beforeShowDay: function (date) {
        var self = options;
        var holiday = getHoliday(date, holidays);
        return [true, holiday ? 'holiday' : '', holiday];
      }
    };
  
    if (opt)
	  $.extend(options, opt);

    inputs.each(function ()
    {
      var input = $(this);

	  if (input.is(":data(datepicker)"))
		  return true;

      input.datepicker(options).on('click.heidateeditfocus', function(e) {
        $(this).datepicker('show');
      });

      if (!input.hasClass("datepicker-disabled"))
      {
        input.nextAll(".ui-datepicker-clear:first").bind("click",
          function ()
          {
            input.datepicker("setDate", null);
            input.trigger('change');
          }
        );
      }
      else
      {
        input.next(".ui-datepicker-trigger").unbind("click");
      }

      if (input.hasClass("datepicker-clicksetsdate"))
      {
        input.bind("click",
          function ()
          {
            var date = input.datepicker("getDate");
            if (date == null)
            {
              input.datepicker("setDate", new Date());
              input.trigger('change');
            }
          }
        );
      }

      if (input.hasClass("datepicker-clearnotallowed"))
      {
        var currDate = input.datepicker("getDate");
        if (currDate == null)
        {
          currDate = new Date();
        }
        input.attr("lastDate", currDate.toDateString());
        input.change(function ()
        {
          var date = input.datepicker("getDate");
          if (date == null)
          {
            input.datepicker("setDate", new Date(input.attr("lastDate")));
          }
          else
          {
            input.attr("lastDate", date.toDateString());
          }
        });
      }
	
	  if (input.hasClass('datepicker-inline')) 
	  {
	    var $img = input.next("img.ui-datepicker-trigger");
	    $img.remove();
	    var $input = $(input);
	    $input.css({'background-image':'url(' + options.buttonImage + ')', 'background-repeat': 'no-repeat', 'background-position': 'right 3px center' });
	  }
    
    });
  }

  function getHoliday(date, holidays) {
    var toCheck = moment(date);

    var selected = holidays.find(function (holidayData) {
      return toCheck.isSame(holidayData.DateObserved, 'day') && holidayData.Hours >= 8;
    });

    var observerd = selected && moment(selected.DateObserved).isSame(selected.OfficialDate) ? '' : '-Observed';
    return selected ? selected.Holiday + observerd : ''; 
  }

  calendarService.Create('GetCompanyHolidays').then(function (days) {
    var holidays = days || [];
    setInput(inputs, holidays)
  }).
  catch(function (err) {
    var holidays = [];
    setInput(inputs, holidays);
  });
};

$(document).ready(function () { new HEIJS.Controls.HEIDateEdit(); });